<template>
  <div class="match-invite-page page">
    <Breadcrumb :type="1"></Breadcrumb>
    <!-- 图片 -->
    <div class="banner-image">
      <img src="@/assets/images/icon-31.png" alt="企业新闻" class="banner-img" />
      <div class="banner-text">
        <h1 class="banner-title">新闻中心</h1>
        <p class="banner-subtitle">关注行业发展，分享通文成长</p>
      </div>
    </div>
    <!-- 标签导航 -->
    <div class="tab-navigation">
      <div class="tab-container">
        <div 
          class="tab-item" 
          :class="{ active: categoryId == '112' }"
          @click="switchTab('112')"
        >
          通文动态
        </div>
        <div 
          class="tab-item" 
          :class="{ active: categoryId == '209' }"
          @click="switchTab('209')"
        >
          媒体报道
        </div>
        <div 
          class="tab-item" 
          :class="{ active: categoryId == '113' }"
          @click="switchTab('113')"
        >
          行业资讯
        </div>
      </div>
    </div>
    <!-- 主体 -->
    <div class="news-content">
      <!-- <img
        v-if="categoryId == 112"
        src="@/assets/images/icon-5.png"
        alt="标题"
        class="image-title"
      />
      <img
        v-if="categoryId == 113"
        src="@/assets/images/icon-9.png"
        alt="标题"
        class="image-title"
      />
      <img
        v-if="categoryId == 209"
        src="@/assets/images/icon-9.png"
        alt="标题"
        class="image-title"
      /> -->
      <!-- 企业新闻 -->
      <ImageNews
        :newsList="newsList"
        v-if="categoryId == 112"
        @handleBannerClick="articleDetailClick"
      ></ImageNews>
      <!-- 媒体报道 -->
      <ImageMedia
        :newsList="newsList"
        v-if="categoryId == 209"
        @handleBannerClick="articleDetailClick"
      ></ImageMedia>
      <!-- 行业资讯 -->
      <ImageInfo
        :newsList="newsList"
        v-if="categoryId == 113"
        @handleBannerClick="articleDetailClick"
      ></ImageInfo>

      <Pagination
        :pageSize="pageSize"
        :pageCount="pageCount"
        @changePageClick="changePageClick"
        v-if="newsList.length > 0"
      ></Pagination>
      <el-empty description="暂无数据" v-if="newsList.length == 0"></el-empty>
    </div>
  </div>
</template>

<script>
// import Breadcrumb from '@/components/common/breadcrumb'
import ImageNews from './components/ImageNews.vue'
import ImageMedia from './components/ImageMedia.vue'
import ImageInfo from './components/ImageInfo.vue'
import Pagination from '@/components/common/Pagination.vue'
import { getArticlePage } from '@/api/home/home.js'
import { getNavItemByCode } from '@/api/common/common.js'
export default {
  name: 'Policy',
  components: {  ImageNews, ImageMedia, Pagination, ImageInfo  },
  data() {
    return {
      pageSize: 6, //分页数量
      pageCount: 0, //列表总数
      displayNewsList: true,

      tabList: [],
      tabTitle: '新闻中心',
      newsList: [],
      article: '',
      pageType: '', //1 文章内容，2 文章列表
      categoryId: '',
      tabcode: '',
      seccode: '',
      subcode: '',
      currentCategory: {
        categoryName: '',
        englishName: ''
      }
    }
  },
  methods: {
    //统一获取数据
    fetchData() {
      if (!this.tabcode) return
      getNavItemByCode(this.tabcode).then((res) => {
        if (!res.data) return
        //侧边栏列表
        this.tabList = res.data[0]

        console.log('this.tabList', this.tabList)

        console.log('this.categoryId', this.categoryId)

        console.log('categoryCode', this.tabList.categoryCode)

        if (this.tabList.categoryCode == this.categoryId) {
          this.currentCategory = this.tabList
        }
        if (this.currentCategory.categoryName == '') {
          let attr = this.tabList.list.filter((p) => {
            if (p.categoryCode == this.categoryId) {
              console.log('categoryName', p.categoryName)
              return p
            }
          })
          if (attr.length) {
            this.currentCategory = attr[0]
          }
        }
      })
      //获取文章列表
      this.getArticlePage()
    },
    //获取header组件的点击事件
    getTab(data) {
      if (data && typeof data == 'string') {
        this.$router.push('/' + data)
      }
    },
    //获取文章列表
    getArticlePage(page = 1) {
      getArticlePage({
        page: page,
        limit: this.pageSize,
        categoryCode: this.categoryId
      }).then((res) => {
        console.log(res.data)
        if (!res.data) return
        this.newsList = res.data.list
        this.pageCount = Number(res.data.count)
      })
    },
    //跳转文章详情
    articleDetailClick(item) {
      if (item.articleUrl) {
        window.open(item.articleUrl)
      } else {
        let url =
          '/articleDetail?categoryId=' +
          this.currentCategory.categoryCode +
          '&linkType=' +
          this.currentCategory.linkType +
          '&tabcode=' +
          this.tabcode +
          '&seccode=' +
          this.seccode +
          '&id=' +
          item.articleId

        this.$router.push({
          path: url
        })
      }
    },
    //切换页面
    changePageClick(page) {
      this.getArticlePage(page)
    },
    //点击改变栏目
    changeSecTab(item, tab) {
      this.currentCategory = item
      console.log('item', this.currentCategory)
      console.log('tab', tab)
      let url =
        '?categoryId=' +
        item.categoryCode +
        '&linkType=' +
        item.linkType +
        '&tabcode=' +
        this.tabcode
      url = tab ? url + '&seccode=' + tab : url

      this.seccode = tab //二级标题
      this.categoryId = item.categoryCode //当前标题
      this.subcode = item.categoryCode //三级标题
      this.pageType = item.linkType
      if (this.tabList.list && this.tabList.list.length > 0) {
        const targetItem = this.tabList.list.find(
          (item) => item.categoryCode == this.categoryId
        )

        if (this.categoryId == this.seccode && targetItem?.list?.length) {
          item = item.list[0]
          this.seccode = targetItem.categoryCode
          this.subcode = targetItem.list[0].categoryCode
          this.categoryId = targetItem.list[0].categoryCode
        }
      }

      // 展示富文本
      //链接类型：1/文章详情,2/单图列表,3/图文列表,4/文本列表,5/切换详情列表,6/新闻详情
      if (item.linkType == 1) {
        this.getArticleData(item.linkUrl)
        url = '/article' + url + '&id=' + item.linkUrl
      }
      if (item.linkType == 2) {
        url = '/singleImage' + url
      }
      if (item.linkType == 3) {
        this.getArticlePage()
        url = '/imageText' + url
      }
      if (item.linkType == 4) {
        url = '/textList' + url
      }
      if (item.linkType == 6) {
        url = '/articleDetail' + url
      }

      this.$router.push({
        path: url
      })
    },
    // 切换标签
    switchTab(categoryId) {
  this.categoryId = categoryId
  // 根据分类ID调整分页数量
  if (categoryId == '113' || categoryId == '209') {
    this.pageSize = 9
  } else {
    this.pageSize = 6
  }
  this.getArticlePage()
}
  },
  created() {
    this.pageType = this.$route.query?.linkType
    this.categoryId = this.$route.query?.categoryId
    this.tabcode = this.$route.query?.tabcode
    this.seccode = this.$route.query?.seccode
    if (this.categoryId == 113 || this.categoryId == 209) {
      this.pageSize = 9
    }
    this.fetchData()
  },
  mounted() {}
}
</script>

<style lang="scss" scoped>
.match-invite-page {
  display: flex;
  flex-direction: column;
  .banner-image {
    width: 100%;
    display: relative;
    position: relative;
    margin: 2px 0;
    height: 350px;
    overflow: hidden;
    .banner-img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
    .banner-text {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        text-align: center;
        color: white;
        text-shadow: 0 2px 4px rgba(0,0,0,0.3);
        letter-spacing: 2px;
        .banner-title {
          font-size: 48px;
          font-weight: bold;
          margin: 0 0 30px 0;
          letter-spacing: 4px;
          line-height: 1.2;
        }
        .banner-subtitle {
          font-size: 24px;
          margin: 0;
          letter-spacing: 4px;
          line-height: 1.4;
        }
      }
  }
  .tab-navigation {
    width: 100%;
    background-color: #f5f5f5;
    margin: 0;
    .tab-container {
      display: flex;
      width: 1200px;
      margin: 0 auto;
      .tab-item {
        flex: 1;
        text-align: center;
        padding: 15px 0;
        font-size: 16px;
        color: #333;
        cursor: pointer;
        transition: all 0.3s ease;
        border-right: 2px solid #e5e5e5;
        &.active {
          background-color: #005bac;
          color: white;
          font-weight: bold;
        }
        &:hover {
          background-color: #d0d0d0ec
        }
        &.active:hover {
          background-color: #005bac;
        }
        &:last-child {
          border-right: none;
        }
      }
    }
  }
  .news-content {
    display: flex;
    flex-direction: column;
    width: 1340px;
    margin: 64px auto 120px;
    .image-title {
      width: 250px;
      height: 64px;
      margin: 0 auto;
    }
  }
}

// 手机端css
.mobile-content {
  .match-invite-page {
    .banner-image {
      margin: 10px 0;
    }
    .tab-navigation {
      .tab-container {
        width: 100%;
        .tab-item {
          padding: 10px 0;
          font-size: 14px;
        }
      }
    }
    .news-content {
      width: 345px;
      margin: 24px auto 60px;
      .image-title {
        width: 150px;
        height: 38.4px;
      }
    }
  }
}
</style>
